import SmartphoneOutlinedIcon from "@mui/icons-material/SmartphoneOutlined";

import type { DriverRow } from "@/types/driver";
import ContextTile from "./ContextTile";

/** Whether the driver is registered on a personal-mode device. */
export default function PersonalDeviceTile({ driver }: { driver: DriverRow }) {
  return (
    <ContextTile
      icon={<SmartphoneOutlinedIcon sx={{ fontSize: 18 }} />}
      label="Personal device"
      value={driver.hasPersonalDevice ? "Yes" : "No"}
    />
  );
}
